module.exports = __webpack_public_path__ + "img/114.402a1341.jpg";